import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

function Square(props) {
  return(

    // winning squares are green
    <button className={ props.winner ? 'square green' : 'square' }onClick={props.onClick}>
      {props.value}
    </button>
  );
}

class Board extends React.Component {
  
  // finding the winning squares and line
   winningSquare(i) {
    if(this.props.winner && this.props.winner.line.findIndex(element => element === i) !== -1) {
        return true;
    }
    return null;
  }
  
  renderSquare(i) {
    return (
      <Square
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}

        // marking winning square
        winner={this.winningSquare(i)}
        key={i}
      />
    );
  }

  render() {
    return (
      
      <div className="game-board">
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    );
  }
}

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [{
        squares: Array(9).fill(null),
      }],
      stepNumber: 0,
      xIsNext: true,
    };
  }

  handleClick(i) {
    const history = this.state.history.slice(0, this.state.stepNumber + 1);
    const current = history[history.length - 1];
    
    const squares = current.squares.slice();

    
    if (calculateWinner(squares) || squares[i]) {
      return;
    }
    squares[i] = this.state.xIsNext ? 'X' : 'O';
    this.setState({
      history: history.concat([{
        squares: squares
      }]),
      stepNumber: history.length,
      xIsNext: !this.state.xIsNext,
    });
  }

  jumpTo(step) {
    this.setState({
      stepNumber: step,
      xIsNext: (step % 2) === 0,
    });
  }
  
  render() {
    const history = this.state.history;
    const current = history[this.state.stepNumber];
    const winner = calculateWinner(current.squares);

    const moves = history.map((step, move) => {
      const desc = move ?
        'Go to move #' + move :
        'Go to game start';
      return (
        <li key={move}>
          <button onClick={() => this.jumpTo(move)}>
            {desc}
          </button>
        </li>
      );
    });

    let status;
    if (winner) {
      status = 'And the winner is ' + winner.name + '!';
    } else {
      status = 'Next player: ' + (this.state.xIsNext ? 'X' : 'O');
    }


    // OSD
    return (
    
      <div>
        <div className="header">
           <h1>Play Tic-Tac-Toe</h1>
        </div>
        <div className="game shrink">
          <div> 
            <Board
              squares={current.squares}
              winner = {winner}
              onClick={(i) => this.handleClick(i)} 
            />
          </div>
          <div className="game-info">
            <div className="status">{status}</div>
            <ol className="">{moves}</ol>
          </div>
        </div>
      </div>
    );
  }
}


// ========================================

ReactDOM.render(<Game />, document.getElementById("root"));

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      
      // gets the winning line and player
      return {
        name: squares[a],
        line: lines[i],
      };
    }
  }
  return null;
}